import { handleApiErrorResponse } from "../lib/helpers";
import {
    testResultsRequestDispatch,
    testResultsRequestGetState,
} from "../lib/test_results_request_store";

export function getResearcherTestResultData(formValues, token) {
    const requestUrl =
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/get?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : "");
    const requestKey = `${requestUrl}::${token || ""}`;
    const requestState = testResultsRequestGetState();

    if (requestState.inFlightByKey[requestKey]) {
        return requestState.inFlightByKey[requestKey];
    }

    const requestPromise = fetch(requestUrl, {
        method: "get",
        headers: { Authorization: "Bearer " + token },
    })
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        })
        .finally(() => {
            testResultsRequestDispatch({
                type: "CLEAR_TEST_RESULT_IN_FLIGHT",
                payload: { requestKey },
            });
        });

    testResultsRequestDispatch({
        type: "SET_TEST_RESULT_IN_FLIGHT",
        payload: {
            requestKey,
            requestPromise,
        },
    });

    return requestPromise;
}

export function getResearcherTestResultOverviewData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/get-overview?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}
export function getTestParicipantsData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/participants?test_id=" +
        formValues.test_id +
        "&type=" +
        formValues.type +
        "&guest_token=" +
        formValues.guest_token +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestQuestionResultData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/question?test_id=" +
        formValues.test_id +
        "&type=" +
        formValues.type +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getPrototypeTestResultData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/prototype-test?test_id=" +
        formValues.test_id +
        "&type=" +
        formValues.type +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getFirstClickResultData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/first-click?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getFiveSecondsTestQuestionResultData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/five-seconds-test-question?test_id=" +
        formValues.test_id +
        "&type=" +
        formValues.type +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}
export function getPreferenceTestQuestionResultData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/preference-test/questions?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getLoadMoreQuestionData(formValues, token, signal) {
    const generateAiSummary =
        formValues.generate_ai_summary === true ||
            formValues.generate_ai_summary === "true"
            ? "true"
            : "false";

    const queryData = {
        test_id: formValues.test_id,
        test_question_id: formValues.test_question_id,
        page: formValues.page,
        search: formValues.search ?? "",
        rating: formValues.rating ? formValues.rating.join(",") : "",
        type: formValues.type,
        sort_column: formValues.sort_column ?? "",
        order_by: formValues.order_by ?? "",
        questiontype: formValues.questiontype ?? "",
        guest_result_token: formValues.guest_result_token ?? "",
        admin_result_token: formValues.admin_result_token ?? "",
        generate_ai_summary: generateAiSummary,
    };
    if (
        formValues.previous_summary != null &&
        String(formValues.previous_summary).trim() !== ""
    ) {
        queryData.previous_summary = formValues.previous_summary;
    }
    const query = new URLSearchParams(queryData).toString();

    return fetch(
        process.env.REACT_APP_API_END_POINT +
        `researcher/test-results/load-more-question?${query}`,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getLoadMoreSurveyQuestionData(formValues, token, signal) {
    const generateAiSummary =
        formValues.generate_ai_summary === true ||
            formValues.generate_ai_summary === "true"
            ? "true"
            : "false";

    const query = new URLSearchParams({
        test_id: formValues.test_id,
        test_question_id: formValues.test_question_id,
        page: formValues.page,
        search: formValues.search ?? "",
        rating: formValues.rating ? formValues.rating.join(",") : "",
        type: formValues.type,
        sort_column: formValues.sort_column ?? "",
        order_by: formValues.order_by ?? "",
        questiontype: formValues.questiontype ?? "",
        guest_result_token: formValues.guest_result_token ?? "",
        admin_result_token: formValues.admin_result_token ?? "",
        generate_ai_summary: generateAiSummary,
        previous_summary: formValues.previous_summary
            ? formValues.previous_summary
            : "",
    }).toString();

    return fetch(
        process.env.REACT_APP_API_END_POINT +
        `researcher/test-results/load-more-question?${query}`,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function deleteAnswerResult(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/delete-answer",
        {
            method: "POST",
            body: formValues,
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}
export function hideResult(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT + "researcher/test-results/hide-result",
        {
            method: "POST",
            body: formValues,
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function reportIssueAnswer(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/report-issue-answer",
        {
            method: "POST",
            body: formValues,
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function ExportTestResult(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/export-test-result",
        {
            method: "POST",
            body: formValues,
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function ReportTesterIntructionTestResult(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/report-tester-instruction",
        {
            method: "POST",
            body: formValues,
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function ReportTesterParticipantTestResult(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/report-tester-participant",
        {
            method: "POST",
            body: JSON.stringify(formValues),
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function ReportTesterParticipantDeletedTestResult(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/delete-report-tester-participant",
        {
            method: "POST",
            body: JSON.stringify(formValues),
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestTreeTestData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/tree-test?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestTreeTestTaskData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/tree-test/task?outcome_filter=" +
        formValues.outcome_filter +
        "&test_id=" +
        formValues.test_id +
        "&page=" +
        formValues.page +
        "&order=" +
        formValues.order +
        "&direction=" +
        formValues.direction +
        "&task_id=" +
        formValues.task_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestTreeTestTaskFirstClickData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/tree-test/task/first-click?test_id=" +
        formValues.test_id +
        "&task_id=" +
        formValues.task_id,
        {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestPreferenceTestData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/preference-test?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}
export function getTestPreferenceTestTaskData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/preference-test/task?test_id=" +
        formValues.test_id +
        "&page=" +
        formValues.page +
        "&order=" +
        formValues.order +
        "&direction=" +
        formValues.direction +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestCardSortingRCategoryesultData(
    formValues,
    token,
    signal
) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/card-sorting-category?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : "") +
        "&page=" +
        formValues.page,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestCardSortingByUserResultData(formValues, token, signal) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/card-sorting-by-user?test_id=" +
        formValues.test_id +
        (formValues.guest_token ? "&guest_token=" + formValues.guest_token : "") +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestCardSortingByUserLoadMoreResultData(
    formValues,
    token,
    signal
) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/card-sorting-load-more-by-user?test_id=" +
        formValues.test_id +
        "&page=" +
        formValues.page +
        "&sort_column=" +
        formValues.sort_column +
        "&order_by=" +
        formValues.order_by +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestCardSortingCardsResultData(formValues, token, signal) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/card-sorting-cards?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : "") +
        "&page=" +
        formValues.page,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal: signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestCardSortingMatrixResultData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/card-sorting-matrix?test_id=" +
        formValues.test_id +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : ""),
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestCardSortingSimilarityMatrixResultData(
    formValues,
    token
) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/card-sorting-similarity-matrix?test_id=" +
        formValues.test_id +
        "&guest_result_token=" +
        formValues.guest_result_token +
        "&admin_result_token=" +
        formValues.admin_result_token,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getFirstClickData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/tree-test/first-click?test_id=" +
        formValues.test_id +
        "&task_id=" +
        formValues.task_id +
        "&guest_result_token=" +
        formValues.guest_result_token +
        "&admin_result_token=" +
        formValues.admin_result_token,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}
export function getTreeChartData(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/tree-test/get-chart?test_id=" +
        formValues.test_id +
        "&task_id=" +
        formValues.task_id +
        "&guest_result_token=" +
        formValues.guest_result_token +
        "&admin_result_token=" +
        formValues.admin_result_token,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function loadMorePrototypeResultData(formValues, token) {
    const generateAiSummary =
        formValues.generate_ai_summary === true ||
            formValues.generate_ai_summary === "true"
            ? "true"
            : "false";

    const query = new URLSearchParams({
        test_id: formValues.test_id,
        test_question_id: formValues.test_question_id,
        page: formValues.page,
        search: formValues.search,
        rating: formValues.rating ? formValues.rating.join(",") : "",
        type: formValues.type,
        sort_column: formValues.sort_column,
        order_by: formValues.order_by,
        questiontype: formValues.questiontype,
        guest_result_token: formValues.guest_result_token,
        admin_result_token: formValues.admin_result_token,
        generate_ai_summary: generateAiSummary,
        previous_summary: formValues.previous_summary,
    }).toString();

    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/load-more-prototype-results?" +
        query,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function loadMoreFirstClickResultData(formValues, token) {
    const generateAiSummary =
        formValues.generate_ai_summary === true ||
            formValues.generate_ai_summary === "true"
            ? "true"
            : "false";

    const query = new URLSearchParams({
        test_id: formValues.test_id,
        test_question_id: formValues.test_question_id,
        page: formValues.page,
        search: formValues.search,
        rating: formValues.rating ? formValues.rating.join(",") : "",
        type: formValues.type,
        sort_column: formValues.sort_column,
        order_by: formValues.order_by,
        questiontype: formValues.questiontype,
        guest_result_token: formValues.guest_result_token,
        admin_result_token: formValues.admin_result_token,
        generate_ai_summary: generateAiSummary,
        previous_summary: formValues.previous_summary,
    }).toString();

    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "researcher/test-results/load-more-first-click-results?" +
        query,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function loadMoreTreeTestQuestionResultData(formValues, token, signal) {
    const generateAiSummary =
        formValues.generate_ai_summary === true ||
            formValues.generate_ai_summary === "true"
            ? "true"
            : "false";

    const queryData = {
        test_id: formValues.test_id,
        test_question_id: formValues.test_question_id,
        page: formValues.page,
        search: formValues.search ?? "",
        rating: formValues.rating ? formValues.rating.join(",") : "",
        type: formValues.type,
        sort_column: formValues.sort_column ?? "",
        order_by: formValues.order_by ?? "",
        questiontype: formValues.questiontype ?? "",
        guest_result_token: formValues.guest_result_token ?? "",
        admin_result_token: formValues.admin_result_token ?? "",
        generate_ai_summary: generateAiSummary,
    };
    if (
        formValues.previous_summary != null &&
        String(formValues.previous_summary).trim() !== ""
    ) {
        queryData.previous_summary = formValues.previous_summary;
    }
    const query = new URLSearchParams(queryData).toString();

    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/result/load-more-tree-test-question-results?" +
        query,
        {
            method: "get",
            headers: { Authorization: "Bearer " + token },
            signal,
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestMethologyService(formValues, token = null) {
    return fetch(
        process.env.REACT_APP_API_END_POINT +
        "test/sharetest?test_id=" +
        formValues.test_id,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getScreenRecordingData(formValues, token) {
    const url =
        process.env.REACT_APP_API_END_POINT +
        "test/prototype-test/task/by-user?" +
        "test_id=" +
        formValues.test_id +
        "&page=" +
        formValues.page +
        "&sort_column=" +
        formValues.sort_column +
        "&order_by=" +
        formValues.order_by +
        "&task_id=" +
        formValues.task_id +
        "&platform=" +
        formValues.platform +
        "&path=" +
        formValues.path +
        (formValues.guest_token ? "&guest_token=" + formValues.guest_token : "") +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : "");

    return fetch(url, {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    })
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                // get error message from body or default to response status
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((error) => {
            handleApiErrorResponse(error);
            throw error; // Ensure the error is re-thrown so it's caught in the caller function
        });
}
export async function getScreenRecordingVideo(formValues, token) {
    const url =
        process.env.REACT_APP_API_END_POINT +
        "test/result/videos/get/" +
        formValues.id +
        "?" +
        (formValues.guest_token ? "&guest_token=" + formValues.guest_token : "") +
        (formValues.guest_result_token
            ? "&guest_result_token=" + formValues.guest_result_token
            : "") +
        (formValues.admin_result_token
            ? "&admin_result_token=" + formValues.admin_result_token
            : "");

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
            },
        });

        // Check content type
        const contentType = response.headers.get("content-type") || "";
        const isJson = contentType.includes("application/json");

        if (!response.ok) {
            const errorData = isJson
                ? await response.json()
                : { message: "Unknown error" };
            throw new Error(
                errorData.message || `HTTP error! Status: ${response.status}`
            );
        }

        if (isJson) {
            // If response is JSON, return it
            const jsonData = await response.json();
            return { type: "json", data: jsonData };
        } else {
            // Otherwise, treat it as a WebM video file
            const videoBlob = await response.blob();
            const videoUrl = URL.createObjectURL(videoBlob);
            return { type: "blob", blob: videoBlob, url: videoUrl };
        }
    } catch (error) {
        handleApiErrorResponse(error);
        throw error; // Ensure error is re-thrown
    }
}

export function generateAISummary(formValues, token) {
    const endpoint = "test/ai/summarize/generate";

    const body = {
        test_id: formValues.test_id,
        question_id: formValues.question_id,
        section: formValues.type,
    };
    if (
        Array.isArray(formValues.question_results) &&
        formValues.question_results.length > 0
    ) {
        body.question_results = formValues.question_results;
    }
    if (formValues.question_title != null) {
        body.question_title = formValues.question_title;
    }
    if (
        formValues.previous_summary != null &&
        String(formValues.previous_summary).trim() !== ""
    ) {
        body.previous_summary = formValues.previous_summary;
    }

    return fetch(process.env.REACT_APP_API_END_POINT + endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        body: JSON.stringify(body),
    })
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function submitAiSummarizeFeedback(formValues, token) {
    return fetch(
        process.env.REACT_APP_API_END_POINT + "test/ai/summarize/feedback",
        {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                test_id: formValues.test_id,
                question_id: formValues.question_id,
                section: formValues.section,
                ai_feedback: formValues.ai_feedback,
            }),
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data ?? { success: true };
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getResearcherTestResultDataV2(testId, token, guestResultToken = "", adminResultToken = "") {
    const queryParams = new URLSearchParams();
    if (guestResultToken) {
        queryParams.append("guest_result_token", guestResultToken);
    }
    if (adminResultToken) {
        queryParams.append("admin_result_token", adminResultToken);
    }
    const query = queryParams.toString();

    return fetch(
        process.env.REACT_APP_IMG_URL + `api/v2/researcher/workspaces/projects/test-result/${testId}/get${query ? `?${query}` : ""}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}

export function getTestParticipantsDataV2(testId, token, guestResultToken = "", adminResultToken = "") {
    const queryParams = new URLSearchParams();
    if (guestResultToken) {
        queryParams.append("guest_result_token", guestResultToken);
    }
    if (adminResultToken) {
        queryParams.append("admin_result_token", adminResultToken);
    }
    const query = queryParams.toString();

    return fetch(
        process.env.REACT_APP_IMG_URL + `api/v2/researcher/workspaces/projects/test-result/${testId}/participants${query ? `?${query}` : ""}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        }
    )
        .then((res) => {
            const isJson = res.headers
                .get("content-type")
                ?.includes("application/json");
            const data = isJson ? res.json() : null;

            if (!res.ok) {
                const error = (data && data.message) || res.status;
                return Promise.reject(error);
            }

            return data;
        })
        .catch((res) => {
            handleApiErrorResponse(res);
        });
}
